import { DataItemFormatter } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { getInitialConditionalAction, getRouteToCallback } from '../../../utils/formattersUtils';
import styles from './SummaryRenderer.module.scss';

const cx = classNames.bind(styles);

const SummaryRenderer: DataItemFormatter<string, ReactElement, { onItemClick? }> = ({
  value: summary,
  item,
  row,
  configuration,
  props,
}) => {
  const { isDisabled, isHovered } = row;
  const routeToCallback = getRouteToCallback(configuration, item);
  const initialConditionalAction = getInitialConditionalAction(configuration, row, props, item);

  return (
    <Link
      to={routeToCallback}
      className={cx('body', { 'gray-out': isDisabled && isHovered })}
      dangerouslySetInnerHTML={{ __html: summary }}
      onClick={initialConditionalAction}
      tabIndex={-1}
    />
  );
};

export default SummaryRenderer;
